import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";

import { FormMultipleChoiceBlock as Block } from "./FormMultipleChoiceBlock";
import { defaultData } from "./FormMultipleChoiceBlockDefaultData";
import { meta } from "./FormMultipleChoiceBlockMetaData";

export const FormMultipleChoiceBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-multiple-choice",
    size: 24,
  },
  meta,
};
